module.exports = __webpack_public_path__ + "img/businessman-man-people-woman-4427924.2a9237b9.jpg";